import * as types from '../mutation-types';

const state = {
  currentPage: {
    me: 0,
    unassigned: 0,
    all: 0,
    appliedFilters: 0,
    // NOTICE: KAPTION-INTEGRATION - "unread" tab added in #132.
    // Without this key, getCurrentPageFilter('unread') returned undefined,
    // pagination computed `undefined + 1 = NaN`, and the chat list fired
    // GET /conversations?page=NaN&conversation_type=unread in an infinite
    // loop until the agent left the tab.
    // SID: unread-filter.PAGINATION.1 unread-filter.PAGINATION.2
    unread: 0,
  },
  hasEndReached: {
    me: false,
    unassigned: false,
    all: false,
    // Same root cause: the infinite-scroll loop's "stop" guard reads this
    // key, and undefined never tripped it.
    unread: false,
  },
};

export const getters = {
  // NOTICE: KAPTION-INTEGRATION - Defensive fallbacks so a future new tab
  // can't reintroduce the page=NaN spam. A non-zero starting `currentPage`
  // never makes sense; an unknown filter behaves as "page 0, not finished".
  getHasEndReached: $state => filter => {
    return $state.hasEndReached[filter] ?? false;
  },
  getCurrentPageFilter: $state => filter => {
    return $state.currentPage[filter] ?? 0;
  },
  getCurrentPage: $state => {
    return $state.currentPage;
  },
};

export const actions = {
  setCurrentPage({ commit }, { filter, page }) {
    commit(types.default.SET_CURRENT_PAGE, { filter, page });
  },
  setEndReached({ commit }, { filter }) {
    commit(types.default.SET_CONVERSATION_END_REACHED, { filter });
  },
  reset({ commit }) {
    commit(types.default.CLEAR_CONVERSATION_PAGE);
  },
};

export const mutations = {
  [types.default.SET_CURRENT_PAGE]: ($state, { filter, page }) => {
    $state.currentPage = {
      ...$state.currentPage,
      [filter]: page,
    };
  },
  [types.default.SET_CONVERSATION_END_REACHED]: ($state, { filter }) => {
    if (filter === 'all') {
      // NOTICE: KAPTION-INTEGRATION - When the "all" list runs out, the
      // narrower views (me / unassigned / unread) by definition can't have
      // more pages either, so cascade the end-reached flag to them too.
      // SID: unread-filter.PAGINATION.4
      $state.hasEndReached = {
        ...$state.hasEndReached,
        unassigned: true,
        me: true,
        unread: true,
      };
    }
    $state.hasEndReached = {
      ...$state.hasEndReached,
      [filter]: true,
    };
  },
  [types.default.CLEAR_CONVERSATION_PAGE]: $state => {
    $state.currentPage = {
      me: 0,
      unassigned: 0,
      all: 0,
      appliedFilters: 0,
      unread: 0,
    };

    $state.hasEndReached = {
      me: false,
      unassigned: false,
      all: false,
      appliedFilters: false,
      unread: false,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
